import "./HowItWorks.module.css";
import Navigation from "@/reusable_sections/Header";
import MethodologyPillars from "./sections/MethodologyPillars";
import TheNetwork from "./sections/TheNetwork";
import StoreFooter from "@/reusable_sections/Footer";
export default function HowItWorksPage() {
  return <div>
      <Navigation />
      <MethodologyPillars />
      <TheNetwork />
      <StoreFooter />
    </div>;
}